import { Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { StyledFpaAppointmetCard } from "../../../styled/form";

const FpaAppointmentCard = ({ turnos, disabled, handleDelete }) => {
  return (
    <StyledFpaAppointmetCard.Container>
      {turnos.map(
        (turno, indiceTurno) =>
          !turno.DesvincularNroTransaccionFpa && (
            <StyledFpaAppointmetCard.Card key={indiceTurno}>
              <StyledFpaAppointmetCard.InfoContainer elevation={2}>
                <StyledFpaAppointmetCard.TurnosContainer>
                  <div>
                    <Typography>
                      Fecha:{" "}
                      {moment(turno.fechaHora).format("DD/MM/YYYY HH:mm")}
                    </Typography>
                    <Typography>
                      Profesional: {turno.profesionalApellidoNombre} (MP.{" "}
                      {turno.matricula}) - {turno.especialidadNombre}
                    </Typography>
                  </div>
                </StyledFpaAppointmetCard.TurnosContainer>
              </StyledFpaAppointmetCard.InfoContainer>
              <StyledFpaAppointmetCard.ActionContainer elevation={2}>
                <Tooltip title="Eliminar">
                  <StyledFpaAppointmetCard.Button
                    disabled={disabled}
                    onClick={() => {
                      if (!disabled) {
                        handleDelete(indiceTurno, turnos);
                      }
                    }}
                  />
                </Tooltip>
              </StyledFpaAppointmetCard.ActionContainer>
            </StyledFpaAppointmetCard.Card>
          ),
      )}
    </StyledFpaAppointmetCard.Container>
  );
};

export default FpaAppointmentCard;
